module.exports = __webpack_public_path__ + "static/media/også.b36ab806.mp3";